import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
    EditableSlideToggle,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffProvincesEdit from '../locations/TaroffProvincesEdit';
import { postData } from '../../Api';

export default function TaroffProvinces(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        applyFilters();
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQTitle('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-provinces/table-data', {
            size: tableSize,
            page: tablePage,
            q_title: filterQTitle,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp2 = (row) => {
        alert('error in editting slide-toggle value')
    };
    const handlecomp3 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffProvincesEdit
                        taroff-provinces-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp4 = (row) => {};
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>استان ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>فعال</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>عنوان لاتین استان</TableColumn>
                        <TableColumn mobile={false}>کد پستی پیشفرض</TableColumn>
                        <TableColumn mobile={false}>کد گیت وی</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <EditableSlideToggle onChange={() => handlecomp2(row)} />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title_en}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_default_post_code}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_gateway_code}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handlecomp3(row)}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش استان'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp4(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
